// 使用更安全的方式获取环境变量
const REACT_ENV = window.REACT_APP_ENV || 'testing';

const baseUrlMaps = {
  // 本地
  'development': {
    dubboCrmBaseURL: 'https://tapi.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: '/mngPath',
    bbMngPath: 'https://sit.apbenben.com/league-mng',
    benbenPath: 'https://web-sit.apbenben.com',
    erpPath: 'https://test.erp.apware.cn',
    dubboErpDockingBaseURL: 'http://localhost:8080/dubbo-erp-docking-web'
  },
  // 测试
  'testing': {
    dubboCrmBaseURL: 'https://tapi.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: 'https://sit.apbenben.com/league-mng',
    bbMngPath: 'https://sit.apbenben.com/league-mng',
    benbenPath: 'https://web-sit.apbenben.com',
    erpPath: 'https://test.erp.apware.cn',
    dubboErpDockingBaseURL: 'https://sit.apbenben.com/dubbo-erp-docking-web'
  },
  // 预发布
  'pre': {
    dubboCrmBaseURL: 'https://papi.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: 'https://pre.apbenben.com/league-mng',
    bbMngPath: 'https://pre.apbenben.com/league-mng',
    benbenPath: 'https://pre.apbenben.com',
    erpPath: 'https://benben.erp.apware.cn',
    dubboErpDockingBaseURL: 'https://pre.apbenben.com/dubbo-erp-docking-web'
  },
  // 正式
  'production': {
    dubboCrmBaseURL: 'https://api.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: 'https://www.apbenben.com/league-mng',
    bbMngPath: 'https://www.apbenben.com/league-mng',
    benbenPath: 'https://web.apbenben.com',
    erpPath: 'https://benben.erp.apware.cn',
    dubboErpDockingBaseURL: 'https://www.apbenben.com/dubbo-erp-docking-web'
  }
};

// 检查 baseUrlMaps[REACT_ENV] 是否存在，如果不存在则使用 development 环境的配置
const config = baseUrlMaps[REACT_ENV] || baseUrlMaps['testing'];
console.log('CommonURL配置:', config);
console.log('CommonURL配置env:', REACT_ENV);
export default config